import { Panel } from '../../panels/panel';
import { WorkspacePanel } from '../../panels/workspace-panel';
import { QueueCreationPanelModal } from './queue-creation-panel-modal';

export function QueueCreationPanel({ panel }: { panel: WorkspacePanel }): React.ReactElement {
    return <Panel panel={panel} body={<QueueCreationPanelModal panel={panel} />} />;
}
